module.exports = __webpack_public_path__ + "bb548ae0a760f73f2a49e21bfff4421d.png";